import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { MINT_MIST } from '../../constants/brandSurfaces';

const blue = '#0d4efe';
const ink = '#1a1a2e';
const muted = '#5a6478';
const deepTeal = '#047857';

export const HeroSection = styled('section')({
  position: 'relative',
  overflow: 'hidden',
  marginTop: 12,
  borderRadius: 24,
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1.15fr) minmax(0, 0.85fr)',
  alignItems: 'center',
  gap: 36,
  padding: '48px 52px',
  background: MINT_MIST,
  border: '1px solid rgba(26, 26, 46, 0.06)',
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
    padding: '36px 28px',
  },
  '@media (max-width: 600px)': {
    borderRadius: 18,
    padding: '26px 18px 24px',
  },
});

export const HeroContent = styled(Box)({
  position: 'relative',
  zIndex: 1,
  textAlign: 'left',
});

export const HeroBadge = styled('p')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  margin: '0 0 16px',
  padding: '6px 12px',
  borderRadius: 999,
  fontSize: '0.86rem',
  fontWeight: 600,
  color: deepTeal,
  background: 'rgba(1, 235, 178, 0.16)',
  '& svg': { fontSize: 18 },
});

export const HeroHeading = styled('h1')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '2.6rem',
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: '-0.02em',
  color: ink,
  margin: '0 0 12px',
  '& em': { fontStyle: 'normal', color: blue },
  '@media (max-width: 900px)': {
    fontSize: '2.2rem',
  },
  '@media (max-width: 600px)': {
    fontSize: '1.75rem',
  },
});

export const HeroSubheading = styled('p')({
  fontSize: '1.1rem',
  lineHeight: 1.55,
  color: muted,
  margin: '0 0 24px',
  maxWidth: 520,
  '@media (max-width: 600px)': {
    fontSize: '1rem',
    marginBottom: 20,
  },
});

export const TrustRow = styled('ul')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px 22px',
  listStyle: 'none',
  padding: 0,
  margin: '18px 0 0',
});

export const TrustItem = styled('li')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  fontSize: '0.95rem',
  fontWeight: 600,
  color: ink,
  '& svg': {
    fontSize: 20,
    padding: 3,
    borderRadius: '50%',
    color: deepTeal,
    background: 'rgba(1, 235, 178, 0.18)',
  },
});

export const ProLink = styled(Link)({
  display: 'inline-block',
  marginTop: 18,
  fontSize: '0.95rem',
  fontWeight: 600,
  color: blue,
  textDecorationColor: 'rgba(13, 78, 254, 0.35)',
  textUnderlineOffset: 3,
  '&:hover': { textDecorationColor: blue },
});

const notActive = { shouldForwardProp: (prop) => prop !== '$active' };

export const HeroPhoto = styled('figure')({
  position: 'relative',
  margin: 0,
  height: 380,
  '@media (max-width: 900px)': {
    display: 'none',
  },
});

export const HeroPhotoImage = styled('img', notActive)(({ $active }) => ({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 20,
  boxShadow: '0 18px 40px rgba(26, 26, 46, 0.14)',
  opacity: $active ? 1 : 0,
  transition: 'opacity 1.8s ease-in-out',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));

export const PhotoNote = styled('figcaption')({
  position: 'absolute',
  zIndex: 1,
  left: -18,
  bottom: 22,
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  maxWidth: 250,
  padding: '12px 16px',
  borderRadius: 14,
  background: '#ffffff',
  boxShadow: '0 10px 28px rgba(26, 26, 46, 0.14)',
  fontSize: '0.88rem',
  fontWeight: 600,
  lineHeight: 1.35,
  color: ink,
  '& svg': {
    flexShrink: 0,
    fontSize: 22,
    color: blue,
  },
});
